import HubRedirect from "@/features/hub/HubRedirect";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_hub/")({
    component: HubRedirect,
    staticData: {
        titleFn: null,
    },
});
